import { Trans } from '@lingui/react/macro';
import '@warp-ds/components/icon';
import { Badge, Button } from '@warp-ds/react';
import { usePulse } from '../../hooks/usePulse.js';
import { getHuckConfig } from '../../utils/getHuckConfig.js';

interface AiDescriptionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const AiDescriptionButton = ({ onClick, disabled, isLoading }: AiDescriptionButtonProps) => {
  const { locale } = getHuckConfig();
  const { trackClick } = usePulse();

  const handleClick = () => {
    trackClick({
      name: 'Get AI description suggestions',
      intent: 'Open',
      object: {
        id: 'TAI_ev14',
        elementType: 'Button',
      },
    });
    onClick();
  };

  return (
    <div className="flex flex-col mb-16">
      <p className="s-text text-m leading-m mb-16">
        <Trans
          id="mobility-item-insertion.form.ai-description.intro"
          comment="Intro text explaining AI description suggestions feature"
        >
          Get help highlighting the most important details about your car. We'll create a suggestion based on the
          information in your listing.
        </Trans>
      </p>
      <div className="flex items-center gap-8">
        <Button
          onClick={handleClick}
          disabled={disabled || isLoading}
          loading={isLoading}
          small
          data-testid="ai-description-trigger"
        >
          <div className="flex items-center justify-center gap-8">
            {!isLoading && <w-icon name="Sparkles" size="small" locale={locale} />}
            <Trans
              id="mobility-item-insertion.form.ai-description.button"
              comment="Button text to fetch AI description suggestions"
            >
              Get description suggestions
            </Trans>
          </div>
        </Button>
        <Badge variant="info">
          <Trans id="mobility-item-insertion.form.ai-description.beta-badge" comment="Beta badge for AI feature">
            Beta
          </Trans>
        </Badge>
      </div>
    </div>
  );
};
